module.exports = __webpack_public_path__ + "static/img/gy_img_banner_a_r.bcdacbb7.png";